import script from "./AutomationBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./AutomationBadge.vue?vue&type=script&setup=true&lang=js"

import "./AutomationBadge.vue?vue&type=style&index=0&id=130d91fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-130d91fd"]])

export default __exports__